import { render, staticRenderFns } from "./LeaveAllowance.vue?vue&type=template&id=7a8d9ad4"
import script from "./LeaveAllowance.vue?vue&type=script&lang=js"
export * from "./LeaveAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports